import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ProductTypeList from "../pages/ProductType/ProductTypeList";
import CreateProductType from "../pages/ProductType/CreateProductType";
import EditProductType from "../pages/ProductType/EditProductType";
//@ts-ignore
import {AccessControl,PermissionRequired} from "@careinfo/permission-required";

export const queryClient = new QueryClient()

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<ProductTypeList />} />
          <Route path="/product-type" element={<ProductTypeList />} />
          <Route path="/create" element={
               <AccessControl
               children={  <CreateProductType />}
               allowedPermissions={["can_view_setting"]}
               renderNoAccess={<PermissionRequired />}
             />
          } />
          <Route path="/edit/:id" element={
               <AccessControl
               children={ <EditProductType />}
               allowedPermissions={["can_view_setting"]}
               renderNoAccess={<PermissionRequired />}
             />
            } />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>

  );
};

export default Router;